import Phaser from 'phaser';
import * as fontConfig from '../scripts/FontConfig.js';


export default class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  preload() {
    // Empty - we handle loading in create() for better control over UI
  }

  create() {
    // Create preloader UI elements
    this.createPreloaderUI();
    
    // Start loading assets
    this.startLoading();
  }

  createPreloaderUI() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    
    // Title
    fontConfig.createText(this, width / 2, height / 2 - 100, 'HYPNOBREAKER', "small", {
      fontSize: '48px',
      fill: '#ecf0f1',
      fontWeight: 'bold'
    }).setOrigin(0.5);
    
    // Loading text
    this.loadingText = fontConfig.createText(this, width / 2, height / 2 - 40, 'Loading...', "small", {

    }).setOrigin(0.5);
    
    // Progress bar background
    const progressBarWidth = 400;
    const progressBarHeight = 20;
    this.progressBarBg = this.add.rectangle(
      width / 2, 
      height / 2, 
      progressBarWidth, 
      progressBarHeight, 
      0x34495e
    );
    
    // Progress bar fill
    this.progressBarFill = this.add.rectangle(
      width / 2 - progressBarWidth / 2, 
      height / 2, 
      0, 
      progressBarHeight - 4, 
      0x3498db
    ).setOrigin(0, 0.5);
    
    // Progress percentage text
    this.progressText = this.add.text(width / 2, height / 2 + 40, '0%', {
      fontSize: '18px',
      fontFamily: 'm6',
      fill: '#ecf0f1'
    }).setOrigin(0.5);
    
    // Asset name text
    this.assetText = this.add.text(width / 2, height / 2 + 70, '', {
      fontSize: '14px',
      fontFamily: 'm6',
      fill: '#95a5a6'
    }).setOrigin(0.5);
  }

  startLoading() {
    // Set up loading event listeners with UI updates
    this.load.on('progress', (value) => {
      // console.log(Math.round(value * 100) + '%');
      
      // Update progress bar
      const progressBarWidth = 400;
      this.progressBarFill.width = progressBarWidth * value;
      
      // Update progress text
      this.progressText.setText(Math.round(value * 100) + '%');
    });
    
    this.load.on('fileprogress', (file) => {
      // console.log('Loading file:', file.src);
      
      // Update loading text and asset name
      const filename = file.src.split('/').pop();
      this.loadingText.setText('Plaatjes laden...');
      this.assetText.setText(filename);
    });
    
    this.load.on('complete', () => {
      // console.log('Loading complete');
      
      // Update UI to show completion
      this.loadingText.setText('Klaar om te starten');
      this.assetText.setText('Starten met het spel...');
      this.progressText.setText('100%');
      
      // Wait a moment then start the group selection
      this.time.delayedCall(500, () => {
        this.scene.start('SelectGroupScene');
      });
    });
    this.load.image('finalScreen', 'assets/finalScreen.png');
    this.load.image('startScreen', 'assets/startScreen.png');
    this.load.image('backgroundScreen', 'assets/backgroundScreen.png');
    this.load.image('creditsScreen', 'assets/creditsScreen.png');

    //intro images
    this.load.image('intro-1', 'assets/intro-1.png');
    this.load.image('intro-2', 'assets/intro-2.png');
    this.load.image('intro-3', 'assets/intro-3.png');
    this.load.image('intro-4', 'assets/intro-4.png');
    this.load.image('intro-5', 'assets/intro-5.png');

    // Load tileset image for Tiled map use
    // Load tileset spritesheet for manual use
    this.load.spritesheet('character', 'assets/character.png', {
      frameWidth: 16,
      frameHeight: 32
    }); 

    this.load.spritesheet('tilemap_packed', 'assets/Modern_Exteriors_Complete_Tileset.png', {
      frameWidth: 16,
      frameHeight: 16
    });

    this.load.spritesheet('tileset', 'assets/Modern_Exteriors_Complete_Tileset.png', {
      frameWidth: 16,
      frameHeight: 16
    });

    // Room tilesets for interior scenes
    this.load.spritesheet('generic', 'assets/1_Generic_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('bedroom', 'assets/4_Bedroom_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('livingroom', 'assets/2_LivingRoom_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('art', 'assets/7_Art_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('gym', 'assets/8_Gym_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('basement', 'assets/14_Basement_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('kitchen', 'assets/12_Kitchen_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('halloween', 'assets/11_Halloween_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('hospital', 'assets/19_Hospital_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('grocerystore', 'assets/16_Grocery_store_16x16.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('ui', 'assets/Modern_UI_Style_2.png', { frameWidth: 16, frameHeight: 16 });
    this.load.spritesheet('speechbubbles', 'assets/speechbubbles.png', { frameWidth: 16, frameHeight: 16 });

    this.load.spritesheet('roombuilder', 'assets/Room_Builder_16x16.png', { frameWidth: 16, frameHeight: 16 });
    // this.load.spritesheet('controls', 'assets/controls.png', {frameHeight: 16, frameWidth: 16   });

    // Load room maps
    this.load.tilemapTiledJSON('room-mo', 'assets/room-mo.json');
    this.load.tilemapTiledJSON('room-julia', 'assets/room-julia.json');
    this.load.tilemapTiledJSON('room-louisa', 'assets/room-louisa.json');
    this.load.tilemapTiledJSON('room-sam', 'assets/room-sam.json');
    this.load.tilemapTiledJSON('room-liam', 'assets/room-liam.json');
    this.load.tilemapTiledJSON('room-treehouse', 'assets/room-treehouse.json');
    this.load.tilemapTiledJSON('room-glasshouse', 'assets/room-glasshouse.json');
    this.load.tilemapTiledJSON('room-hospital', 'assets/room-hospital.json');
    this.load.tilemapTiledJSON('room-grocerystore', 'assets/room-grocerystore.json');
    // Load conversation tilemap
    this.load.tilemapTiledJSON('conversation', 'assets/conversation.json');
    this.load.tilemapTiledJSON('reflection', 'assets/reflection.json');
    
    // Load friends UI tilemap for overlay
    this.load.tilemapTiledJSON('friends-ui', 'assets/friends-ui.json');
    this.load.tilemapTiledJSON('controls', 'assets/controls.json');
    
    // Load home button spritesheet (3 states: neutral, hover, down - each 48x48px)
    this.load.spritesheet('homebutton', 'assets/homebutton.png', {
      frameWidth: 48,
      frameHeight: 48
    });
    
    // Load friend placeholder images for overlay UI
    const friendList = ['julia', 'liam', 'louisa', 'mo', 'sam'];
    const states = ['happy', 'hypno'];
    
    friendList.forEach(friend => {
      states.forEach(state => {
        this.load.image(`placeholder-${friend}-${state}`, `assets/placeholder-${friend}-${state}.png`);
      });
    });
    this.load.image('hypno', 'assets/hypno.png');
    
    // Load friend portraits (320x320px)
    const friends = ['mo', 'julia', 'liam', 'louisa', 'sam'];
    const moods = ['neutral', 'happy', 'angry', 'hypno'];
    
    friends.forEach(friend => {
      moods.forEach(mood => {
        this.load.image(`${friend}-${mood}`, `assets/portraits/${friend}-${mood}.png`);
        this.load.image(`room-${friend}`, `assets/room-${friend}.png`);
        this.load.image(`${friend}-sprite`, `assets/${friend}-sprite.png`);
        this.load.image(`${friend}-room-happy`, `assets/${friend}-room-happy.png`);
        this.load.image(`${friend}-room-neutral`, `assets/${friend}-room-neutral.png`);
        this.load.image(`${friend}-room-hypno`, `assets/${friend}-room-hypno.png`);
        this.load.spritesheet(`${friend}`, `assets/${friend}-sprite.png`, {
          frameWidth: 16,
          frameHeight: 32
        });
      });
    });
    
    // Load hero portraits (320x320px)
    const heroes = ['hero-boy', 'hero-girl'];
    heroes.forEach(hero => {
      moods.forEach(mood => {
        this.load.image(`${hero}-${mood}`, `assets/portraits/${hero}-${mood}.png`);
      });
    });
    
    // Load Tiled JSON map
    this.load.tilemapTiledJSON('map', 'assets/Hypnotown-2.json');

    // Start the actual loading process
    this.load.start();
  }
}
